// extracted by mini-css-extract-plugin
export var required = "_gx-0";